import { useEffect, useState } from 'react';
import SnackBar from 'components/SnackBar';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import useFetchData from '../../../hooks/useFetchData';
import fields from '../fields';
import { useParams } from 'react-router-dom';
import { find } from 'lodash';

const UserPage = () => {
  const { id: userUuid } = useParams();
  const [currentuser, setCurrentUser] = useState();
  const { postData, res, payload, error } = usePostData();
  const [showSnackbar, setShowSnakbar] = useState(false);
  const [errFun, setErrFun] = useState();

  let { data } = useFetchData('user', userUuid);

  let { data: rolesList } = useFetchData('role');

  useEffect(() => {
    setCurrentUser(data);
  }, [data]);

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError,
      });
    else if (res && res.affected === 1 && payload) {
      setCurrentUser(payload);
      setShowSnakbar(true);
    }
  }, [res, payload, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    let deepData = { ...data };
    delete deepData.id;
    deepData.roleId = find(rolesList, { name: deepData.role })?.id;
    delete deepData.role;
    console.log('update user data  :', deepData);
    postData(`user/${userUuid}`, deepData, 'patch');
  };

  return (
    <div className="create-user">
      {currentuser && (
        <div>
          <SectionHeader
            title={`${currentuser?.first_name} ${currentuser?.last_name}`}
          ></SectionHeader>
          {rolesList && (
            <FormGroup
              fields={fields(rolesList)}
              data={currentuser}
              onSubmit={onSubmit}
            ></FormGroup>
          )}
          {showSnackbar && (
            <SnackBar
              msg={'משתמש עודכן'}
              handleClose={() => setShowSnakbar(false)}
            ></SnackBar>
          )}
        </div>
      )}
    </div>
  );
};

export default UserPage;
